import React, { useRef } from 'react';
import { Form } from 'react-bootstrap';
import { useCheckInLogic } from '../../hooks/useCheckIn';
import useClickOutside from '../../hooks/useClickOutside';

const StudentSearch: React.FC = () => {
  const {
    state,
    setSearchTerm,
    setShowDropdown,
    clearStudentSelection,
    handleStudentSelect,
    resetInteractionTimer,
  } = useCheckInLogic();

  const searchRef = useRef<HTMLDivElement>(null);
  useClickOutside(searchRef, () => setShowDropdown(false));

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
    resetInteractionTimer();
  };

  const handleInputFocus = () => {
    if (state.selectedStudent) {
      setSearchTerm('');
      clearStudentSelection();
    }
    setShowDropdown(true);
    searchRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    resetInteractionTimer();
  };


  const handleStudentClick = (student: typeof state.filteredStudents[0]) => {
    handleStudentSelect(student);
  };

  const textInputClassNames = state.selectedStudent ? "mb-2 fw-bolder form-control-dark" : "mb-2 form-control-dark";

  return (
    <div className="mb-4 position-relative" ref={searchRef}>
      <Form.Label className="h4 mb-3">Select Your Name</Form.Label>
      <div className="position-relative">
        <Form.Control
          type="text"
          placeholder="Touch here to see all names or type to search..."
          value={state.searchTerm}
          onChange={handleInputChange}
          onFocus={handleInputFocus}
          size="lg"
          className={textInputClassNames}
          style={{ 
            fontSize: '1.2rem', 
            paddingRight: state.selectedStudent ? '50px' : '12px' 
          }}
        />
      </div>
      
      {state.showDropdown && !state.selectedStudent && (
        <div 
          className="position-absolute w-100 dark-dropdown" 
          style={{ 
            maxHeight: '300px', 
            overflowY: 'auto',
            zIndex: 1000
          }}
        >
          {state.filteredStudents.length > 0 ? (
            <>
              {state.filteredStudents.map((student) => (
                <div
                  key={student.id}
                  className="p-3 dark-dropdown-item"
                  style={{
                    fontSize: '1.1rem'
                  }}
                  onClick={() => handleStudentClick(student)}
                >
                  <strong>{student.name}</strong>
                </div>
              ))}
            </>
          ) : (
            <div className="p-3 text-center dark-dropdown-empty">
              {state.searchTerm ? 'No students found' : 'Loading students...'}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default StudentSearch;